module.exports = __webpack_public_path__ + "img/ys2.32b24042.png";